import { makeAutoObservable, runInAction } from 'mobx';
import { request } from '@src/common';
import { HelperCore } from '@/common/helper';
import inputTypeStore from '../input-file/input-type';
import Loader from '@/common/helper/loader';
import slsLogger from '@public/log/sls';
import userStore from '@/store/user';
class Store {
  list_create = [];
  list_share = [];
  total_create = 0;
  total_share = 0;
  page_share = 1;
  page_create = 1;
  curId = null;
  ksId = null;
  showList = false;
  loaded = {};  // 是否已完成首次加载

  get list_default() {
    if (this.list_create?.length) {
      return this.list_create.filter(item => item.is_default == 1);
    } else {
      return [];
    }
  }

  get isReady () {
    return this.loaded["1"] && this.loaded["0"];
  }

  constructor() {
    makeAutoObservable(this);

    if (!HelperCore.IS_PROD) {
      window._knowledgeChoiceStore = this;
    }
  }

  /**
   * 选择模型
   */
  switchCurId = id => {
    this.curId = id;

    if (this.curId) {
      inputTypeStore.reset();
    }
  };
  setKsId = ks_id => {
    this.ksId = ks_id;
  };
  resetCurId = () => {
    this.curId = null;
    this.ksId = null;
  };
  resetData = () => {
    this.resetCurId();
  };

  /**
   * 加载知识库列表
   */
  loadList = async type => {
    const isShare = type == 1;
    return request
      .get('/knowledge/list', {
        params: {
          page: isShare ? this.page_share : this.page_create,
          size: 50, // 最大 50
          type, // 0:我创建的 1:我加入的
        },
      })
      .then(res => {
        if(!HelperCore.IS_ONLINE && !HelperCore.IS_LOCAL){
          slsLogger.log({
            key : "preview",
            action : `knowledge_list_result`,
            ext : type,
            ext2 : JSON.stringify(res),
          });
        }

        runInAction(() => {
          const listData = (res.data?.list || []).map(item => {
            return {
              ...item,
              ...{
                name: Loader.getFixedKnowledgeName(item.name),
              },
            };
          });
          if (isShare) {
            this.list_share = listData;

            if(listData.length && !listData.filter(item => item.ks_id).length){
              slsLogger.log({
                key : "preview",
                action : "error_sharelist",
                ext : JSON.stringify(this.list_share),
                ext2 : JSON.stringify(res),
              });
            }
          } else {
            this.list_create = listData;

            if(!this.list_create?.length){
              slsLogger.log({
                key : "preview",
                action : "error_sharelist",
                ext : JSON.stringify(this.list_create),
                ext2 : JSON.stringify(res),
              });
            }
          }
        });
      })
      .catch(res => {
        if(!userStore.isUser){
          return;
        }

        slsLogger.log({
          key : "preview",
          action : "error_knowledgelist",
          ext2 : JSON.stringify(res),
        });
      })
      .finally(() => {
        runInAction(() => {
          this.loaded = {
            ...this.loaded,
            [type] : true,
          }
        })
      })
  };

  /**
   * 是否显示下拉列表
   */
  setShowList = async show => {
    // 即时更新，有可能在新 tab 上增删了知识库
    if (show && userStore.isUser) {
      // 如果之前未加载或加载失败
      if(!this.list_create?.length && !this.list_share?.length){
        slsLogger.log({
          key : "preview",
          action : "empty_knowledgelist",
          ext : JSON.stringify(this.list_create),
          ext2 : JSON.stringify(this.list_share),
        });
        
        try{
          await this.loadList(0);
        } catch(e){}
        try{
          await this.loadList(1);
        } catch(e){}
      }
      else {
        this.loadList(0);
        this.loadList(1);
      }
    }

    this.showList = show;
  };

  /**
   * 用于输入框发送新会话
   * 已废弃，改用新知识库多选
   */
  getNewChatParams() {
    return {};

    if (!this.curId) {
      return {};
    }
    return {
      ks_id: this.ksId,
      dataset: {
        [this.curId]: [],
      },
    };
  }

  /**
   * 是否是我自己的知识库
   * @param {String} knowledgeId 
   * @returns 
   */
  isMyKnowledge (knowledgeId) {
    return !!this.list_create.find(item => item.folder_id == knowledgeId);
  }
  isMyKnowledgeAsync = async (knowledgeId) => {
    await this.loadList(0);
    return this.isMyKnowledge(knowledgeId);
  }

  /**
   * 通过知识库 ID 获取 ks_id
   * @param {String} knowledgeId 
   */
  getKsId (knowledgeId) {
    const knowledge = this.list_share.find(item => item.folder_id == knowledgeId);

    if(!knowledge?.ks_id){
      slsLogger.log({
        key : "preview",
        action : "error_ksid",
        ext : JSON.stringify(this.list_share),
        ext1 : knowledgeId,
      });
    }

    return knowledge?.ks_id || "";
  }
}

const knowledgeChoiceStore = new Store();
export default knowledgeChoiceStore;
